/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Vault_Delete_WarningInputs */

const en_vault_delete_warning = /** @type {(inputs: Vault_Delete_WarningInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Warning: Deleting this file will immediately remove access for all active subscribers of this tier.`)
};

const es_vault_delete_warning = /** @type {(inputs: Vault_Delete_WarningInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Advertencia: Eliminar este archivo eliminará inmediatamente el acceso para todos los suscriptores activos de este nivel.`)
};

const fr_vault_delete_warning = /** @type {(inputs: Vault_Delete_WarningInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Avertissement : La suppression de ce fichier supprimera immédiatement l'accès pour tous les abonnés actifs de ce niveau.`)
};

const de_vault_delete_warning = /** @type {(inputs: Vault_Delete_WarningInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Warnung: Das Löschen dieser Datei entzieht sofort allen aktiven Abonnenten dieser Stufe den Zugriff.`)
};

const id_vault_delete_warning = /** @type {(inputs: Vault_Delete_WarningInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Peringatan: Menghapus file ini akan segera menghapus akses untuk semua pelanggan aktif dari tingkat ini.`)
};

/** @type {(inputs: Vault_Delete_WarningInputs) => LocalizedString} */
const ja_vault_delete_warning = en_vault_delete_warning;

/** @type {(inputs: Vault_Delete_WarningInputs) => LocalizedString} */
const zh_vault_delete_warning = en_vault_delete_warning;

/** @type {(inputs: Vault_Delete_WarningInputs) => LocalizedString} */
const ar_vault_delete_warning = en_vault_delete_warning;

/** @type {(inputs: Vault_Delete_WarningInputs) => LocalizedString} */
const it_vault_delete_warning = en_vault_delete_warning;

/** @type {(inputs: Vault_Delete_WarningInputs) => LocalizedString} */
const ru_vault_delete_warning = en_vault_delete_warning;

/** @type {(inputs: Vault_Delete_WarningInputs) => LocalizedString} */
const pt_vault_delete_warning = en_vault_delete_warning;

/** @type {(inputs: Vault_Delete_WarningInputs) => LocalizedString} */
const ko_vault_delete_warning = en_vault_delete_warning;

/**
* | output |
* | --- |
* | "Warning: Deleting this file will immediately remove access for all active subscribers of this tier." |
*
* @param {Vault_Delete_WarningInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const vault_delete_warning = /** @type {((inputs?: Vault_Delete_WarningInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Vault_Delete_WarningInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_vault_delete_warning(inputs)
	if (locale === "es") return es_vault_delete_warning(inputs)
	if (locale === "fr") return fr_vault_delete_warning(inputs)
	if (locale === "de") return de_vault_delete_warning(inputs)
	if (locale === "ja") return ja_vault_delete_warning(inputs)
	if (locale === "zh") return zh_vault_delete_warning(inputs)
	if (locale === "ar") return ar_vault_delete_warning(inputs)
	if (locale === "id") return id_vault_delete_warning(inputs)
	if (locale === "it") return it_vault_delete_warning(inputs)
	if (locale === "ru") return ru_vault_delete_warning(inputs)
	if (locale === "pt") return pt_vault_delete_warning(inputs)
	return ko_vault_delete_warning(inputs)
});